import { render, staticRenderFns, recyclableRender, components } from "./index.vue?vue&type=template&id=54d3589c&scoped=true&"
var renderjs
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d3589c",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/details/index.vue"
export default component.exports